import { cva } from 'class-variance-authority';

export const deparmentCVA = cva('font-normal', {
  variants: {
    variant: {
      _: 'border-black-500 text-black-500',
      V: 'border-red-500 text-red-500',
      W: 'border-blue-500 text-blue-500',
      E: 'border-yellow-600 text-yellow-600',
      K: 'border-green-600 text-green-600',
    },
  },
  defaultVariants: {
    variant: '_',
  },
});
